var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import * as SvgIcons from '@ntuctech/devex-tangram/Icon';
import clsx from 'clsx';
import styled from 'styled-components';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import { ICONS_ALL } from '../utils/icon-group';
const AvatarSC = styled.div `
  display: flex;
`;
const AvatarImage = styled.div `
  background-image: url(${(props) => props.image});
  background-size: cover;
  border-radius: ${(props) => (props.shape === 'square' ? '4px' : '50%')};

  border: ${(props) => (props.keyline ? '1px solid #f2f2f2' : 'none')};
  box-sizing: border-box;

  width: ${(props) => props.theme.SizeWidthAvatarSmall};
  height: ${(props) => props.theme.SizeHeightAvatarSmall};

  &._ndsAvtr--extraSmall {
    width: ${(props) => props.theme.SizeWidthAvatarExtraSmall};
    height: ${(props) => props.theme.SizeHeightAvatarExtraSmall};
  }
  &._ndsAvtr--small {
    width: ${(props) => props.theme.SizeWidthAvatarSmall};
    height: ${(props) => props.theme.SizeHeightAvatarSmall};
  }
  &._ndsAvtr--medium {
    width: ${(props) => props.theme.SizeWidthAvatarMedium};
    height: ${(props) => props.theme.SizeHeightAvatarMedium};
  }
  &._ndsAvtr--large {
    width: ${(props) => props.theme.SizeWidthAvatarLarge};
    height: ${(props) => props.theme.SizeHeightAvatarLarge};
  }
  &._ndsAvtr--extraLarge {
    width: ${(props) => props.theme.SizeWidthAvatarExtraLarge};
    height: ${(props) => props.theme.SizeHeightAvatarExtraLarge};
  }
`;
const AvtarIconCP = styled.div `
  background: ${(props) => props.bgColor};
  background-size: cover;

  border: ${(props) => (props.keyline ? '1px solid #f2f2f2' : 'none')};
  border-radius: ${(props) => (props.shape === 'square' ? '4px' : '50%')};
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;

  width: ${(props) => props.theme.SizeWidthAvatarSmall};
  height: ${(props) => props.theme.SizeHeightAvatarSmall};

  &._ndsAvtr--extraSmall {
    width: ${(props) => props.theme.SizeWidthAvatarExtraSmall};
    height: ${(props) => props.theme.SizeHeightAvatarExtraSmall};
  }

  &._ndsAvtr--small {
    width: ${(props) => props.theme.SizeWidthAvatarSmall};
    height: ${(props) => props.theme.SizeHeightAvatarSmall};
  }

  &._ndsAvtr--medium {
    width: ${(props) => props.theme.SizeWidthAvatarMedium};
    height: ${(props) => props.theme.SizeHeightAvatarMedium};
  }

  &._ndsAvtr--large {
    width: ${(props) => props.theme.SizeWidthAvatarLarge};
    height: ${(props) => props.theme.SizeHeightAvatarLarge};
  }

  &._ndsAvtr--extraLarge {
    width: ${(props) => props.theme.SizeWidthAvatarExtraLarge};
    height: ${(props) => props.theme.SizeHeightAvatarExtraLarge};
  }
`;
const AvtarIcon = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${(props) => props.theme.SizeWidthAvatarIconSmall};
  height: ${(props) => props.theme.SizeHeightAvatarIconSmall};
  min-width: ${(props) => props.theme.SizeWidthAvatarIconSmall};
  min-height: ${(props) => props.theme.SizeHeightAvatarIconSmall};

  svg._ndsAvtr--extraSmall {
    width: ${(props) => props.theme.SizeWidthAvatarIconExtraSmall};
    height: ${(props) => props.theme.SizeHeightAvatarIconExtraSmall};
    min-width: ${(props) => props.theme.SizeWidthAvatarIconExtraSmall};
    min-height: ${(props) => props.theme.SizeHeightAvatarIconExtraSmall};
  }

  svg._ndsAvtr--small {
    width: ${(props) => props.theme.SizeWidthAvatarIconSmall};
    height: ${(props) => props.theme.SizeHeightAvatarIconSmall};
    min-width: ${(props) => props.theme.SizeWidthAvatarIconSmall};
    min-height: ${(props) => props.theme.SizeHeightAvatarIconSmall};
  }

  svg._ndsAvtr--medium {
    width: ${(props) => props.theme.SizeWidthAvatarIconMedium};
    height: ${(props) => props.theme.SizeHeightAvatarIconMedium};
    min-width: ${(props) => props.theme.SizeWidthAvatarIconMedium};
    min-height: ${(props) => props.theme.SizeHeightAvatarIconMedium};
  }

  svg._ndsAvtr--large {
    width: ${(props) => props.theme.SizeWidthAvatarIconLarge};
    height: ${(props) => props.theme.SizeHeightAvatarIconLarge};
    min-width: ${(props) => props.theme.SizeWidthAvatarIconLarge};
    min-height: ${(props) => props.theme.SizeHeightAvatarIconLarge};
  }

  svg._ndsAvtr--extraLarge {
    width: ${(props) => props.theme.SizeWidthAvatarIconExtraLarge};
    height: ${(props) => props.theme.SizeHeightAvatarIconExtraLarge};
    min-width: ${(props) => props.theme.SizeWidthAvatarIconExtraLarge};
    min-height: ${(props) => props.theme.SizeHeightAvatarIconExtraLarge};
  }
`;
const AvatarChild = styled.div `
  align-self: center;

  margin-left: ${(props) => props.theme.SizeMarginAvatarLeftSmall};

  &._ndsAvtr--extraSmall {
    margin-left: ${(props) => props.theme.SizeMarginAvatarLeftExtraSmall};
  }

  &._ndsAvtr--small {
    margin-left: ${(props) => props.theme.SizeMarginAvatarLeftSmall};
  }

  &._ndsAvtr--medium {
    margin-left: ${(props) => props.theme.SizeMarginAvatarLeftMedium};
  }

  &._ndsAvtr--large {
    margin-left: ${(props) => props.theme.SizeMarginAvatarLeftLarge};
  }

  &._ndsAvtr--extraLarge {
    margin-left: ${(props) => props.theme.SizeMarginAvatarLeftExtraLarge};
  }
`;
const Avatar = (props) => {
    const { children, image, size, variant, iconType, iconColor, avatarBgColor, keyline } = props, rest = __rest(props, ["children", "image", "size", "variant", "iconType", "iconColor", "avatarBgColor", "keyline"]);
    const resolvedClassName = React.useMemo(() => clsx({
        '_ndsAvtr--extraSmall': size === 'xs',
        '_ndsAvtr--small': size === 's',
        '_ndsAvtr--medium': size === 'm',
        '_ndsAvtr--large': size === 'l',
        '_ndsAvtr--extraLarge': size === 'xl'
    }), [size]);
    const SvgIcon = SvgIcons[iconType];
    const IconComp = SvgIcon;
    return (React.createElement(React.Fragment, null,
        variant === 'image' && (React.createElement(AvatarSC, null,
            React.createElement(AvatarImage, Object.assign({ className: resolvedClassName, image: image, keyline: keyline }, rest)),
            React.createElement(AvatarChild, Object.assign({ className: resolvedClassName }, rest), children))),
        variant === 'icon' && (React.createElement(AvatarSC, null,
            React.createElement(AvtarIconCP, Object.assign({ className: resolvedClassName, bgColor: avatarBgColor, keyline: keyline }, rest),
                React.createElement(AvtarIcon, null, IconComp && React.createElement(IconComp, { className: resolvedClassName, color: iconColor }))),
            React.createElement(AvatarChild, Object.assign({ className: resolvedClassName }, rest), children)))));
};
Avatar.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    image: PropTypes.string,
    size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
    variant: PropTypes.oneOf(['image', 'icon']),
    iconType: PropTypes.oneOf(ICONS_ALL),
    iconColor: PropTypes.string,
    avatarBgColor: PropTypes.string,
    keyline: PropTypes.bool,
    shape: PropTypes.string
};
Avatar.defaultProps = {
    children: null,
    variant: 'image',
    size: 's',
    image: '',
    iconType: 'SvgUserFilled',
    iconColor: '#000000',
    avatarBgColor: '#f6f6f6',
    keyline: false,
    shape: 'round'
};
export { Avatar as AvatarRootComp };
export default withForwardedRef(Avatar);
//# sourceMappingURL=Avatar.js.map